// Lamhenow theme mode. The Beige/Dark switcher was removed from the header (audit G3).
// If no switcher is present on the page, force the default beige look and clear any saved
// "dark" choice so returning visitors are not stuck in a mode they can no longer change.
(function () {
  var STORAGE_KEY = 'lamhenow-theme';

  function applyTheme(theme) {
    if (theme === 'dark') {
      document.documentElement.setAttribute('data-theme', 'dark');
    } else {
      document.documentElement.removeAttribute('data-theme');
    }
    document.querySelectorAll('.theme-toggle__btn').forEach(function (btn) {
      btn.setAttribute('aria-pressed', String(btn.dataset.theme === theme));
    });
  }

  function read() {
    try { return localStorage.getItem(STORAGE_KEY) || 'beige'; } catch (e) { return 'beige'; }
  }

  function write(theme) {
    try { localStorage.setItem(STORAGE_KEY, theme); } catch (e) {}
  }

  function clear() {
    try { localStorage.removeItem(STORAGE_KEY); } catch (e) {}
  }

  function init() {
    var buttons = document.querySelectorAll('.theme-toggle__btn');
    if (!buttons.length) {
      clear();
      applyTheme('beige');
      return;
    }
    applyTheme(read());
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        applyTheme(btn.dataset.theme);
        write(btn.dataset.theme);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
